import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
    state: {
        userList: [],
    },
    mutations: {
    },
    actions: {
        async exportOccupation(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportOccupation`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportTag(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportTag`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportInfoCentre(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportInfoCentre`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportResource(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportResource`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
    },
    getters: {
    }
}

export default moduleStore;